export default class {
  static projectName = "IDPL";
  static userData = "USER_DATA";
  static themeColor = "#087d82";
  static themeColor1 = "#6ea12f";
  static emailRjx = /\S+@\S+\.\S+/;
  // static API_URL = "http://192.168.1.148:7001";
  // static API_URL = "http://192.168.1.114:8087";
  // static API_URL = "http://192.168.1.49:7000";
  // static API_URL = "http://192.168.238.192:8087";
  static API_URL = "http://44.195.135.173:7000";
}